'use strict';

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var ES2015 = require('./es2015');
var assign = require('./helpers/assign');
var ES2016 = assign(assign({}, ES2015), {
  // https://github.com/tc39/ecma262/pull/60
  SameValueNonNumber: function SameValueNonNumber(x, y) {
    if (typeof x === 'number' || _typeof(x) !== _typeof(y)) {
      throw new TypeError('SameValueNonNumber requires two non-number values of the same type.');
    }
    return this.SameValue(x, y);
  }
});
module.exports = ES2016;